/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, MenuItem, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter } from 'react-router-dom';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import WithContexts from '../../../contexts/withContexts';
import { COLORS } from '../../../utils/Application_Constants';

const styles = (theme) => ({
    menuIcon: {
        color: COLORS.LT_MIDNIGHT25,
        display: 'flex',
        alignItems: 'center',
    },
    menuIconCopyADay: {
        color: COLORS.LT_STEEL,
    },
});

function CopyADayMenuItem(props) {
    const { classes, index, entryType, setAnchorEl, setShowCopyADayMenu, isDisabled, isMobile } =
        props;

    return (
        <MenuItem
            onClick={(event) => {
                if (!isMobile) {
                    setAnchorEl(event.currentTarget);
                }

                setShowCopyADayMenu(true);
            }}
            id={`${entryType}--${index}--menu--list-item--copy-a-day`}
            disabled={isDisabled}
        >
            <Grid container alignItems="center" spacing={2}>
                <Grid item className={classes.menuIcon}>
                    <FileCopyOutlinedIcon fontSize="small" className={classes.menuIconCopyADay} />
                </Grid>
                <Grid item>
                    <Typography variant="body2">Copy a Day</Typography>
                </Grid>
            </Grid>
        </MenuItem>
    );
}

export default WithContexts(withRouter(withTranslation()(withStyles(styles)(CopyADayMenuItem))));
